import React from 'react';
import { Link } from 'react-router-dom';
import { Star } from 'lucide-react';
import { Button } from '../components/ui/button';
import { Card, CardContent } from '../components/ui/card';

const Home = () => {
  const reviews = [
    {
      name: 'Marie L.',
      rating: 5,
      text: 'Une photographe exceptionnelle ! Djennah a su capturer avec douceur et professionnalisme les premiers jours de notre petite Léa. Des souvenirs précieux que nous chérirons toute notre vie.',
      date: 'Il y a 2 mois'
    },
    {
      name: 'Sophie D.',
      rating: 5,
      text: 'Un moment magique et plein d\'émotions. Le studio est cosy, Djennah est à l\'écoute et patiente. Les photos sont magnifiques, naturelles et lumineuses. Je recommande à 100% !',
      date: 'Il y a 1 mois'
    },
    {
      name: 'Laura M.',
      rating: 5,
      text: 'Nous avons fait la séance grossesse et naissance. Quelle expérience incroyable ! Djennah nous a mis tellement à l\'aise. Les photos sont sublimes, on ne peut que recommander.',
      date: 'Il y a 3 semaines'
    }
  ];

  return (
    <div className="bg-[#FAF8F5]">
      {/* Hero Section */}
      <section className="hero-section relative overflow-hidden">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20 md:py-32">
          <div className="grid md:grid-cols-2 gap-12 items-center">
            <div className="space-y-6">
              <h1 className="font-heading text-4xl md:text-5xl lg:text-6xl font-semibold text-[#6B5845] leading-tight">
                Photographe spécialisée en maternité à Haguenau
              </h1>
              <p className="font-heading text-2xl text-[#8B7355]">
                9 ans d'émotions partagées
              </p>
              <p className="font-body text-base text-[#6B5845] leading-relaxed">
                Depuis maintenant 9 ans, je me consacre avec passion à la photographie de maternité en Alsace. Plus de 550 familles m'ont déjà accordé leur confiance pour capturer ce moment si précieux : l'attente d'un enfant, ce lien unique entre une mère, un père et la vie qui s'apprête à naître.
              </p>
              <Link to="/contact">
                <Button className="bg-[#8B7355] hover:bg-[#6B5845] text-white font-body px-8 py-6 text-base rounded-lg btn-primary">
                  Réserver une séance
                </Button>
              </Link>
            </div>
            <div className="rounded-lg shadow-lg overflow-hidden">
              <img 
                src="https://customer-assets.emergentagent.com/job_woolurban/artifacts/92ffsekk_4N9A5734.jpg" 
                alt="Photographe maternité Haguenau - Parents avec nouveau-né" 
                className="w-full h-[500px] object-cover"
              />
            </div>
          </div>
        </div>
      </section>

      {/* Intro Section */}
      <section className="py-20 bg-[#F5EDE4]">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center space-y-6">
            <p className="font-body text-lg text-[#6B5845] leading-relaxed max-w-4xl mx-auto">
              Mon approche de photographe est guidée par la douceur, la tendresse et l'authenticité. Chaque séance photo est une parenthèse, un moment intime et chaleureux où vous pouvez être simplement vous, entourés d'amour, dans un cadre rassurant et bienveillant dans notre studio photo à 15 minutes de Haguenau.
            </p>
            <p className="font-body text-lg text-[#6B5845] leading-relaxed max-w-4xl mx-auto">
              En tant que photographe maternité, je mets un point d'honneur à créer des images naturelles, lumineuses, qui racontent votre histoire avec sincérité. Des regards complices, une main posée sur un ventre rond, un sourire discret… ce sont ces petits instants que je m'attache à immortaliser avec délicatesse.
            </p>
            <p className="font-body text-lg text-[#6B5845] leading-relaxed max-w-4xl mx-auto">
              Parce que chaque shooting grossesse est unique, je prends le temps de vous écouter, de vous guider, et de vous offrir des souvenirs qui traverseront les années avec émotion.
            </p>
            <p className="font-heading text-2xl text-[#8B7355] mt-8">
              Bienvenue dans mon univers.
            </p>
            <p className="font-heading text-xl text-[#8B7355]">
              Je suis Djennah, votre Photographe maternité à Haguenau.
            </p>
          </div>
        </div>
      </section>

      {/* Services Highlight */}
      <section className="py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="font-heading text-3xl md:text-4xl font-semibold text-[#6B5845] mb-4">
              Photographe naissance et grossesse à Haguenau
            </h2>
            <p className="font-heading text-xl text-[#8B7355]">
              Des souvenirs doux et authentiques
            </p>
          </div>

          <div className="max-w-5xl mx-auto space-y-6">
            <p className="font-body text-base text-[#6B5845] leading-relaxed">
              Vous recherchez une photographe naissance ou un shooting photo grossesse en Alsace ? Depuis plus de 9 ans, j'accompagne les familles dans ces instants uniques, empreints d'amour et de douceur. Spécialisée dans la photographie de grossesse et de nouveau-né, je mets tout mon savoir-faire au service de vos souvenirs.
            </p>
            <p className="font-body text-base text-[#6B5845] leading-relaxed">
              Chaque shooting grossesse est pensé pour vous offrir un moment de calme, de connexion et de bienveillance. Dans notre studio photo ou en extérieur, à Strasbourg ou ailleurs en Alsace, je crée des images naturelles, lumineuses et pleines d'émotion. Que vous attendiez votre premier enfant ou que votre famille s'agrandisse, chaque séance est personnalisée, à votre image.
            </p>
            <p className="font-body text-base text-[#6B5845] leading-relaxed">
              Les séances photo nouveau-né sont réalisées dans le respect du rythme de bébé, avec beaucoup de patience et de tendresse. Mon expérience auprès de plus de 550 familles me permet d'aborder chaque séance avec douceur et professionnalisme, pour capturer les premiers instants de vie dans un univers chaleureux et sécurisé.
            </p>
            <p className="font-body text-base text-[#8B7355] leading-relaxed font-medium">
              Photographe en Alsace passionnée et à l'écoute, je vous accompagne dans toutes les étapes de votre aventure familiale.
            </p>
          </div>

          {/* Images Grid */}
          <div className="grid md:grid-cols-3 gap-6 mt-12">
            <div className="rounded-lg shadow-lg overflow-hidden service-card">
              <img 
                src="https://customer-assets.emergentagent.com/job_woolurban/artifacts/ok1mv5c6_4N9A8860.png" 
                alt="Séance photo grossesse Haguenau Alsace" 
                className="w-full h-80 object-cover"
              />
            </div>
            <div className="rounded-lg shadow-lg overflow-hidden service-card">
              <img 
                src="https://customer-assets.emergentagent.com/job_woolurban/artifacts/a3bilmc5_8..jpg" 
                alt="Photographe naissance Haguenau - Photo famille avec bébé" 
                className="w-full h-80 object-cover"
              />
            </div>
            <div className="rounded-lg shadow-lg overflow-hidden service-card">
              <img 
                src="https://customer-assets.emergentagent.com/job_woolurban/artifacts/l0dfk30i_photo%2071.jpg" 
                alt="Photographe maternité Haguenau Alsace" 
                className="w-full h-80 object-cover"
              />
            </div>
          </div>
        </div>
      </section>

      {/* Google Reviews Section */}
      <section className="py-20 bg-[#F5EDE4]">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="font-heading text-3xl md:text-4xl font-semibold text-[#6B5845] mb-2">
              Ils nous ont fait confiance
            </h2>
            <p className="font-body text-base text-[#8B7355]">
              Découvrez les avis de nos familles sur Google
            </p>
          </div>

          <div className="grid md:grid-cols-3 gap-8">
            {reviews.map((review, index) => (
              <Card key={index} className="bg-white border-[#E8DCC8] service-card">
                <CardContent className="p-6">
                  <div className="flex mb-3">
                    {[...Array(review.rating)].map((_, i) => (
                      <Star key={i} size={18} className="fill-[#F5C542] text-[#F5C542]" />
                    ))}
                  </div>
                  <p className="font-body text-sm text-[#6B5845] leading-relaxed mb-4">
                    {review.text}
                  </p>
                  <div className="flex justify-between items-center">
                    <p className="font-body text-sm font-medium text-[#8B7355]">{review.name}</p>
                    <p className="font-body text-xs text-[#8B7355]">{review.date}</p>
                  </div>
                </CardContent>
              </Card>
            ))}
          </div>

          <div className="text-center mt-8">
            <a 
              href="https://www.google.com/search?q=yastudioproduction" 
              target="_blank" 
              rel="noopener noreferrer"
              className="font-body text-sm text-[#8B7355] hover:text-[#6B5845] underline"
            >
              Voir tous les avis sur Google
            </a>
          </div>
        </div>
      </section>

      {/* Instagram CTA Section */}
      <section className="py-20">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center space-y-6">
          <h2 className="font-heading text-3xl font-semibold text-[#6B5845]">
            Suivez nos créations sur Instagram
          </h2>
          <p className="font-body text-base text-[#6B5845] leading-relaxed">
            Découvrez nos dernières séances photo maternité et naissance, nos coulisses et bien plus encore !
          </p>
          <a 
            href="https://www.instagram.com/yastudio_photography/" 
            target="_blank" 
            rel="noopener noreferrer"
          >
            <Button className="bg-gradient-to-r from-[#E1306C] to-[#FD1D1D] hover:opacity-90 text-white font-body px-8 py-6 text-base rounded-lg btn-primary inline-flex items-center space-x-2">
              <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
                <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"/>
              </svg>
              <span>Suivez-nous sur Instagram</span>
            </Button>
          </a>
        </div>
      </section>
    </div>
  );
};

export default Home;